"use client"

import { Drumstick } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DrumstickIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DrumstickIcon = component(Icon)({ as: Drumstick })
